import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HomPage from './HomePage';
import AboutUs from './Pages/AboutUs';
import Services from './Pages/Services';
import Products from './Pages/Products';
import Careers from './Pages/Careers';
import ContactUs from './Pages/ContactUs';
import CorporateTraining from './Pages/CorporateTraining';
import { Toaster } from 'react-hot-toast';
import Faq from './Pages/Faq';
import Testimonials from './Pages/Testimonials';
import EnquiryCard from './Components/EnquiryCard';

// Products 
import CoreHR360 from './Products-page/CoreHR360';
import AutoFinance from './Products-page/AutoFinance';
import ClothingEcommerce from './Products-page/ClothingEcommerce';
import BillingSoftware from './Products-page/BillingSoftware';
import LogisticsManagement from './Products-page/LogisticsManagement';




function App() {
  useEffect(() => {
  const cursor = document.querySelector(".custom-cursor__cursor");
  const cursorInner = document.querySelector(".custom-cursor__cursor-two");

  let mouseX = 0;
  let mouseY = 0;
  let cursorX = 0;
  let cursorY = 0;

  const moveCursor = (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  };

  const animate = () => {
    // Smooth follow effect (lerp)
    cursorX += (mouseX - cursorX) * 0.15; 
    cursorY += (mouseY - cursorY) * 0.15;

    if (cursor) {
      cursor.style.left = `${cursorX}px`;
      cursor.style.top = `${cursorY}px`;
    }

    if (cursorInner) {
      cursorInner.style.left = `${mouseX}px`; // inner one snaps
      cursorInner.style.top = `${mouseY}px`;
    }

    requestAnimationFrame(animate);
  };

  // Hover effect on links and buttons
  const addHoverEvents = () => {
    const elements = document.querySelectorAll("a, button");

    elements.forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursor?.classList.add("custom-cursor__hover");
        cursorInner?.classList.add("custom-cursor__innerhover");
      });
      el.addEventListener("mouseleave", () => {
        cursor?.classList.remove("custom-cursor__hover");
        cursorInner?.classList.remove("custom-cursor__innerhover");
      });
    });
  };

  window.addEventListener("mousemove", moveCursor);
  addHoverEvents();
  animate();

  return () => {
    window.removeEventListener("mousemove", moveCursor);
  };
}, []);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};


  return (
    <>
<Toaster position="top-center" reverseOrder={false} />
      <Router>
      <EnquiryCard />
      <ScrollToTop />
      
        <Routes>
          <Route path="/" element={<HomPage />} />
          <Route path="aboutUs" element={<AboutUs />} />
          <Route path='services' element={<Services/>} />
          <Route path='products' element={<Products/>} />
          <Route path='careers' element={<Careers/>} />
          <Route path='contactUs' element={<ContactUs/>} />
          <Route path='corporateTraining' element={<CorporateTraining/>} />
          <Route path='faq' element={<Faq/>} />
          <Route path='testimonials' element={<Testimonials/>} />

          {/* Product-Pages */}
          <Route path='core-hr-360' element={<CoreHR360/>} />
          <Route path='auto-finance' element={<AutoFinance/>} />
          <Route path='clothing-ecommerce' element={<ClothingEcommerce/>} />
          <Route path='billing-software' element={<BillingSoftware/>} />
          <Route path='logistics-management' element={<LogisticsManagement/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
